type Props = {
  name?: string
  address?: string
  phone?: string
  logoUrl?: string
}

/**
 * The clinic letterhead for the visit summary's letterhead slot: logo (when the deployment has one),
 * name, address and phone — each left out when unknown (see utils/clinicBranding for the sources).
 */
const ClinicLetterhead = ({ name, address, phone, logoUrl }: Props) => {
  if (!name && !address && !phone && !logoUrl) return null

  return (
    <div className="flex items-center gap-3">
      {logoUrl && (
        <img
          alt={name ? `${name} logo` : 'Clinic logo'}
          className="max-h-14 w-auto max-w-[8rem] shrink-0 object-contain"
          src={logoUrl}
        />
      )}
      <div className="min-w-0">
        {name && <p className="text-base font-bold uppercase">{name}</p>}
        {address && <p className="text-xs text-[#555]">{address}</p>}
        {phone && <p className="text-xs text-[#555]">Tel: {phone}</p>}
      </div>
    </div>
  )
}

export default ClinicLetterhead
